import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
  Button,
} from '@mui/material';
import { Link } from 'react-router-dom';
import NavigationBar from '../components/NavigationBar';

const services = [
  {
    title: 'Accesorios de tecnología',
    description:
      'Audífonos bluetooth, mouse gamer, teclados retroiluminados, memorias USB y tintas Epson/Canon originales y genéricas.',
    bullets: ['Audífonos y manos libres', 'Mouse, teclados y pads', 'Memorias USB y microSD', 'Tintas Epson/Canon'],
    image:
      'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=1200&q=80',
  },
  {
    title: 'Sublimación creativa',
    description:
      'Tazas, playeras y llaveros personalizados con calidad profesional para eventos, empresas o regalos especiales.',
    bullets: ['Tazas mágicas y clásicas', 'Playeras deportivas y casuales', 'Llaveros metálicos y de MDF'],
    image:
      'https://images.unsplash.com/photo-1475180098004-ca77a66827be?auto=format&fit=crop&w=1200&q=80',
  },
  {
    title: 'Artículos de librería',
    description:
      'Todo lo que necesitas para escuela y oficina: cuadernos, borradores, lápices, lapiceros, folders y más.',
    bullets: ['Cuadernos profesionales', 'Folders plásticos y Manila', 'Borradores, lápices y lapiceros'],
    image:
      'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=1200&q=80',
  },
  {
    title: 'Manualidades y detalles',
    description:
      'Ramos, regalos personalizados y detalles para toda ocasión. Diseños únicos hechos a mano con amor.',
    bullets: ['Ramos temáticos', 'Regalos corporativos', 'Decoraciones especiales'],
    image:
      'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1200&q=80',
  },
  {
    title: 'Servicios digitales',
    description:
      'Impresiones, fotocopias y trámites digitales: certificados de nacimiento, matrimonio, antecedentes y RENAS.',
    bullets: ['Impresiones y fotocopias', 'Certificados RENAP', 'Antecedentes penales/policiales/RENAS'],
    image:
      'https://images.unsplash.com/photo-1518780664697-55e3ad937233?auto=format&fit=crop&w=1200&q=80',
  },
];

const ServicesPage = () => (
  <>
    <NavigationBar />
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1b033d 0%, #44108f 50%, #7821d6 100%)',
        color: 'white',
        pb: 10,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage:
            'radial-gradient(circle at 10% 20%, rgba(255,255,255,0.12), transparent 40%), radial-gradient(circle at 80% 0%, rgba(0,255,255,0.15), transparent 25%)',
          opacity: 0.8,
        }}
      />
      <Container maxWidth="lg" sx={{ pt: 10, position: 'relative', zIndex: 1 }}>
        <Stack spacing={2} textAlign="center" mb={6}>
          <Typography variant="overline" sx={{ letterSpacing: 4 }}>
            Servicios integrales
          </Typography>
          <Typography variant="h3" fontWeight={800}>
            Todo lo que tu negocio y hogar necesitan
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.8)' }}>
            Tecnología, creatividad y trámites digitales con un estilo moderno y futurista.
          </Typography>
        </Stack>

        <Grid container spacing={4}>
          {services.map((service) => (
            <Grid item xs={12} md={6} key={service.title}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: 4,
                  bgcolor: 'rgba(13,20,60,0.8)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  boxShadow: '0 20px 50px rgba(5,5,20,0.6)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  component="img"
                  src={service.image}
                  alt={service.title}
                  sx={{ width: '100%', height: 220, objectFit: 'cover' }}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" fontWeight={700} gutterBottom>
                    {service.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)', mb: 2 }}>
                    {service.description}
                  </Typography>
                  <Stack spacing={1}>
                    {service.bullets.map((bullet) => (
                      <Typography key={bullet} variant="body2">
                        • {bullet}
                      </Typography>
                    ))}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Stack spacing={2} alignItems="center" mt={6}>
          <Typography variant="h5" fontWeight={600}>
            ¿Listo para llevar tu experiencia al siguiente nivel?
          </Typography>
          <Button
            variant="contained"
            size="large"
            component={Link}
            to="/catalogo"
            sx={{
              borderRadius: 999,
              px: 4,
              py: 1.5,
              backgroundImage: 'linear-gradient(90deg, #00d4ff, #7c3aed)',
            }}
          >
            Ver catálogo completo
          </Button>
        </Stack>
      </Container>
    </Box>
  </>
);

export default ServicesPage;
